import styled from "styled-components";
import {
  border,
  color,
  flexbox,
  grid,
  layout,
  position,
  space,
} from "styled-system";
import type { TypeMenuContentProps } from "./MenuContentTypes";

export const StyledMenuContent = styled.ul<TypeMenuContentProps>`
  margin: 0;
  padding: 0;
  overflow: auto;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  ${border}
  ${color}
  ${flexbox}
  ${grid}
  ${layout}
  ${space}
  ${position}
`;
